import React from "react";
import { LazyLoadImages, ResponsiveImage, Link } from "@quintype/components";
import PropTypes from "prop-types";
import get from "lodash.get";
import { getSlug } from "../../../utils/utils";
import "./magazine-cover-image.m.css";

export const MagazineCoverImageCard = ({ collection, config }) => {
  const imgAltText = get(collection, ["metadata", "magazine", "name"], "cover-image");
  const {
    "cover-image-url": coverUrl,
    "cover-image-s3-key": covers3Key,
    "cover-image-metadata": coverImageMetaData
  } = get(collection, ["metadata", "cover-image"], {});

  const slug = collection && getSlug(collection, config);

  return (
    <div styleName="cover-image">
      <figure styleName="image">
        {covers3Key ? (
          <Link href={slug}>
            <LazyLoadImages>
              <ResponsiveImage
                slug={covers3Key}
                aspectRatio={[1, 2]}
                metadata={{ coverImageMetaData }}
                defaultWidth={400}
                imgParams={{ auto: ["format", "compress"] }}
                alt={imgAltText}
              />
            </LazyLoadImages>
          </Link>
        ) : (
          <img src={coverUrl} alt="cover-image" loading="lazy" />
        )}
      </figure>
    </div>
  );
};

MagazineCoverImageCard.propTypes = {
  collection: PropTypes.shape({
    "cover-image-url": PropTypes.string,
    "cover-image-s3-key": PropTypes.string,
    "cover-image-metadata": PropTypes.string,
    slug: PropTypes.string
  }),
  config: PropTypes.object
};
